import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomSelect from "../../component/CustomSelect";

const addEndpoint = ApiEndpoints.team.Create;

const teamCategories = [
    { _id: "management_teams", name: "Management" },
    { _id: "board_of_directors", name: "Board Of Director" }
  ]

export default function AddTeam() {
  const navigate = useNavigate();

  const [previews, setPreviews] = useState({ image: null, });

  const [postData, setPostData] = useState({ name: "", team_category: "", designation: "", description: "", image: null, alt_image: "", facebook_link: "", instagram_link: "", x_link: "", linkedin_link: "", });


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

  const optionalFields = [
    "brief",
    "facebook_link",
    "instagram_link",
    "x_link",
    "linkedin_link"
  ];
    for (const [key, value] of Object.entries(postData)) {
      if (!optionalFields.includes(key)  && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", addEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/teams");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Team Management',
    user: 'Admin',
    innerpage: 'Team Management / Team / Add Team'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="newsAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Designation<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="designation" type="text" className="form-control" placeholder="Enter Designation" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>facebook profile url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="facebook_link" type="text" className="form-control"  placeholder="Facebook Link" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>instagram profile url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="instagram_link" type="text" className="form-control"  placeholder="Instagram Link" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>X profile url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="x_link" type="text" className="form-control"  placeholder="X Link" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>linkedin profile url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="linkedin_link" type="text" className="form-control"  placeholder="Linkedin Link" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>team category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"team_category"} options={teamCategories} placeholder="Select Category" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Alt For Image<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="alt_image" type="text" className="form-control" required placeholder="Alt Tag" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Image (140 × 140)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description} onChange={(event, editor) => handleEditorChange("description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="newsAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
